import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa5b10a0&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=aa5b10a0&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=aa5b10a0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5b10a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa5b10a0')) {
      api.createRecord('aa5b10a0', component.options)
    } else {
      api.reload('aa5b10a0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=aa5b10a0&scoped=true&lang=pug", function () {
      api.rerender('aa5b10a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/supplementaryAgreement/index.vue"
export default component.exports